import { useLeftNavHasOwnedAgents } from './useLeftNavHasOwnedAgents';
import { useLeftNavHasSponsoredAgents } from './useLeftNavHasSponsoredAgents';
/**
 * Hook to determine if agent management should be available for the current user
 * @returns Object with hasAnyAgents boolean, loading state, and error state
 */
export const useLeftNavAgentConditions = () => {
  const ownedAgentsQuery = useLeftNavHasOwnedAgents();
  const sponsoredAgentsQuery = useLeftNavHasSponsoredAgents();
  return {
    hasAnyAgents: ownedAgentsQuery.data === true || sponsoredAgentsQuery.data === true,
    isLoading: ownedAgentsQuery.isLoading || sponsoredAgentsQuery.isLoading,
    error: ownedAgentsQuery.error || sponsoredAgentsQuery.error,
    isSuccess: ownedAgentsQuery.isSuccess && sponsoredAgentsQuery.isSuccess,
  };
};